import {
    Button,
    Card,
    CardContent,
    Chip,
    Dialog,
    DialogTitle,
    Drawer,
    Grid,
    IconButton,
    Menu,
    MenuItem,
    Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TimeHelper from '../../../../../../utils/time';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { SCUIButton } from '../../../../../../atomic/atoms';
import UserSaleOrderStatusHistoryDrawer from '../../../UserSaleOrderStatusHistoryDrawer/UserSaleOrderStatusHistoryDrawer';
import DigitalCardInfo from './components/DigitalCardInfo';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import Tooltip from '@mui/material/Tooltip';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import StoreIcon from '@mui/icons-material/Store';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useHistory } from 'react-router';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CreateIcon from '@mui/icons-material/Create';
import ListAltIcon from '@mui/icons-material/ListAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import CancelOrder from './components/CancelOrder';
import ListIcon from '@mui/icons-material/List';
import CloseIcon from '@mui/icons-material/Close';
import CopyToClipboardButton from '@/atomic/atoms/SCUICopyToClipboardButton/SCUICopyToClipboardButton';
import { OIC, oicCls } from './orderInformationCard.classes';

function OrderInformationCard({ datas }: any) {
    const { t } = useTranslation();
    const history = useHistory();

    const data = datas;

    const digitalDelivery = 11;
    const shipToCustomerAddress = 1;
    const storePickup = 2;
    const buyForMe = 20;

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isGiftCardDrawerOpen, setIsGiftCardDrawerOpen] = useState(false);
    const [open, setOpen] = React.useState(false);
    const canCreateRefund = datas?.canStoreUserCreateRefund ?? true;

    const toggleDrawer = (open: any) => (event: any) => {
        if (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift')) {
            return;
        }
        setIsDrawerOpen(open);
    };
    const toggleGiftCardDrawer = (open: boolean) => () => {
        setIsGiftCardDrawerOpen(open);
    };
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event: any) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handlePushUrlRefund = (url: any) => {
        history.push(``);
        history.push(url);
    };
    const handleClose = (e: any) => {
        e.stopPropagation();

        setAnchorEl(null);
    };

    const handleOpenModal = () => {
        setOpen(true);
    };

    const handleCloseModal = () => {
        setOpen(false);
    };
    return (
        <>
            <Drawer
                anchor="top"
                open={isDrawerOpen}
                onClose={toggleDrawer(false)}
                slotProps={{ paper: { className: OIC.drawerStatusHistoryPaper } }}
            >
                <UserSaleOrderStatusHistoryDrawer orderId={datas.orderId} onClose={toggleDrawer(false)} />
            </Drawer>
            <Drawer
                anchor="right"
                open={isGiftCardDrawerOpen}
                onClose={toggleGiftCardDrawer(false)}
                slotProps={{ paper: { className: OIC.drawerGiftCardPaper } }}
            >
                <DigitalCardInfo
                    orderId={datas.orderId}
                    orderDate={datas.orderDate}
                    customerId={datas.customerId}
                    onClose={toggleGiftCardDrawer(false)}
                />
            </Drawer>
            <Dialog
                open={open}
                onClose={handleCloseModal}
                slotProps={{ paper: { className: OIC.dialogCancelPaper } }}
            >
                <DialogTitle className={OIC.dialogCancelTitleRow}>
                    {t('orderDetail.cancelOrder')}
                    <IconButton
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                        className={OIC.dialogCancelCloseButton}
                        onClick={handleCloseModal}
                    >
                        <CloseIcon
                            className="svg_icons"
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                textAlign: 'right',
                            }}
                        />
                    </IconButton>
                </DialogTitle>
                {data.orderStatusId == 2 && data.deliveryMethodId !== digitalDelivery && (
                    <CancelOrder handleCloseModal={handleCloseModal} />
                )}
            </Dialog>
            <Grid
                sx={{ boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}
                className={oicCls('orderInfos', OIC.root)}
                size={{
                    xs: 12,
                    sm: 12,
                    md: 12
                }}>
                <Card
                    className={OIC.headerCard}
                    sx={{
                        padding: '1rem',
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <div className={OIC.headerTitleRow} style={{ display: 'flex', padding: '1rem' }}>
                        <ShoppingCartIcon className={OIC.headerIcon} style={{ marginTop: '0.5rem' }} />
                        <h3 className={OIC.headerTitle} style={{ marginLeft: '0.5rem' }}>
                            <strong> {t('orderDetail.orderInfos')}</strong>
                        </h3>
                    </div>
                    <div className={OIC.headerActions} style={{ display: 'flex', gap: '2rem' }}>
                        <div className={OIC.statusChipWrap} style={{ marginTop: '1rem' }}>
                            {datas?.orderStatusDescription == 'Teslim Edildi' ? (
                                <Chip className={OIC.chipOrderStatus} label={t('orderDetail.delivered')} color="success" />
                            ) : (
                                datas?.orderStatusDescription && (
                                    <Chip className={OIC.chipOrderStatus} label={datas.orderStatusDescription} color="info" />
                                )
                            )}
                        </div>
                        {data.deliveryMethodId === shipToCustomerAddress && (
                            <div className={OIC.deliveryIconWrap} style={{ padding: '1rem' }}>
                                <Tooltip title={t('orderDetail.ShipToCustomerAddress')}>
                                    <LocalShippingIcon
                                        className={OIC.deliveryIcon}
                                        style={{
                                            color: 'rgb(82, 142, 231)',
                                            width: '25px',
                                            height: 'auto',
                                        }}
                                    />
                                </Tooltip>
                            </div>
                        )}
                        {data.deliveryMethodId === storePickup && (
                            <div className={OIC.deliveryIconWrap} style={{ padding: '1rem' }}>
                                <Tooltip title={t('orderDetail.StorePickup')}>
                                    <StoreIcon
                                        className={OIC.deliveryIcon}
                                        style={{
                                            color: 'rgb(82, 142, 231)',
                                            width: '25px',
                                            height: 'auto',
                                        }}
                                    />
                                </Tooltip>
                            </div>
                        )}
                        {data.deliveryMethodId === digitalDelivery && (
                            <div className={OIC.deliveryIconWrap} style={{ padding: '1rem' }}>
                                <Tooltip title={t('orderDetail.DigitalDelivery')}>
                                    <CardGiftcardIcon
                                        className={OIC.deliveryIcon}
                                        style={{
                                            color: 'rgb(82, 142, 231)',
                                            width: '25px',
                                            height: 'auto',
                                        }}
                                    />
                                </Tooltip>
                            </div>
                        )}
                        {data.deliveryMethodId === buyForMe && (
                            <div className={OIC.deliveryIconWrap} style={{ padding: '1rem' }}>
                                <Tooltip title={t('orderDetail.BuyForMe')}>
                                    <ShoppingBasketIcon
                                        className={OIC.deliveryIcon}
                                        style={{
                                            color: 'rgb(82, 142, 231)',
                                            width: '25px',
                                            height: 'auto',
                                        }}
                                    />
                                </Tooltip>
                            </div>
                        )}
                        {data.deliveryMethodId == digitalDelivery && (
                            <SCUIButton
                                className={OIC.inputButtonGiftCard}
                                type={'secondary'}
                                sizeType={'fixed'}
                                size={'m'}
                                showStartIcon={true}
                                onClick={toggleGiftCardDrawer(true)}
                                text={'Hediye Kart Bilgileri'}
                            ></SCUIButton>
                        )}
                        <Tooltip title={t('orderDetail.orderStatusHistory')}>
                            <Button
                                className={oicCls('orderHistory', OIC.inputButtonOrderHistory)}
                                style={{ border: 'solid 1px', height: '50px' }}
                                onClick={toggleDrawer(true)}
                                startIcon={<AccessTimeIcon style={{ marginRight: '8px' }} />}
                            />
                        </Tooltip>
                        <div className={oicCls('shipment-more-button', OIC.moreMenuWrap)}>
                            <IconButton
                                className={OIC.inputButtonMore}
                                aria-label="more"
                                aria-controls="long-menu"
                                aria-haspopup="true"
                                onClick={handleClick}
                                style={{
                                    padding: '12px',
                                    backgroundColor: 'transparent',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '4px',
                                }}
                            >
                                <MoreHorizIcon style={{ width: '25px', height: 'auto', color: '#666' }} />
                            </IconButton>
                        </div>
                        <Menu
                            className={OIC.actionsMenu}
                            id="long-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={(e: any) => handleClose(e)}
                        >
                            {canCreateRefund && (
                                <MenuItem
                                    className={OIC.menuItemCreateReturn}
                                    onClick={() => handlePushUrlRefund(`/createReturn?orderNumber=${data.orderNumber}`)}
                                >
                                    <ListItemIcon>
                                        <CreateIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={t('orderDetail.createReturn')} />
                                </MenuItem>
                            )}
                            <MenuItem
                                className={OIC.menuItemReturnList}
                                onClick={() => handlePushUrlRefund(`/returnList?OrderNumber=${data.orderNumber}`)}
                            >
                                <ListItemIcon>
                                    <ListIcon />
                                </ListItemIcon>
                                <ListItemText primary={t('orderDetail.returnList')} />
                            </MenuItem>
                            <MenuItem
                                className={OIC.menuItemRefundList}
                                onClick={() => handlePushUrlRefund(`/refundListV2?orderNumber=${data.orderNumber}`)}
                            >
                                <ListItemIcon>
                                    <ListAltIcon />
                                </ListItemIcon>
                                <ListItemText primary={t('customerInformation.returnPaymentList')} />
                            </MenuItem>
                            {data.orderStatusId == 2 && data.deliveryMethodId !== digitalDelivery && (
                                <MenuItem className={OIC.menuItemCancelOrder} onClick={handleOpenModal}>
                                    <ListItemIcon>
                                        <CancelIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={t('return.cancel')} />
                                </MenuItem>
                            )}
                        </Menu>
                    </div>
                </Card>
                <div className={OIC.divider} style={{ height: '2px', background: 'lightGray' }}></div>
                <Card className={oicCls('classes.card', OIC.bodyCard)}>
                    <CardContent className={OIC.bodyContent}>
                        <>
                            <p className={OIC.orderNumberRow}>
                                {t('orderDetail.orderNo')} <strong>{datas.orderNumber}</strong>
                                <span className={OIC.copyOrderNumberWrap}>
                                    <CopyToClipboardButton textToCopy={datas.orderNumber} />
                                </span>
                            </p>
                            <Typography className={OIC.orderDateRow} variant="body2">
                                {t('orderDetail.orderDate')}: {TimeHelper.formatDateHour(data.orderDate)}
                            </Typography>
                            <Typography
                                className={OIC.orderIdRow}
                                variant="body2"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                {t('orderDetail.orderId')} : <span>{data.orderId}</span>
                                <span className={OIC.copyOrderIdWrap}>
                                    <CopyToClipboardButton textToCopy={data.orderId} />
                                </span>
                            </Typography>
                        </>
                    </CardContent>
                </Card>
            </Grid>
        </>
    );
}

export default OrderInformationCard;
